module.exports = __webpack_public_path__ + "img/OmniVisionTechnologies.42944334.jpg";